import { Button, IconTrash16 } from '@cian/ui-kit';
import * as React from 'react';

export interface IDeleteButtonProps {
  showPreloader: boolean;
  onDeleteCommentClick(): void;
}

export class DeleteButton extends React.PureComponent<IDeleteButtonProps, {}> {
  public render() {
    const { onDeleteCommentClick, showPreloader } = this.props;

    return (
      <Button
        size="XS"
        loading={showPreloader}
        onClick={onDeleteCommentClick}
        theme="fill_secondary"
        beforeIcon={<IconTrash16 color="primary_100" />}
        title="Удалить заметку"
      />
    );
  }
}
